import React, { useState, useEffect } from "react";
import { observer, inject } from "mobx-react";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import AlertComponent from "../../components/common/AlertComponent";
import {
  userLogin,
  userLoginSMS,
} from "../../utils/api/Meeting/Auth/user";
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  LinearProgress,
  InputAdornment,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  DialogContent,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff, Close } from "@mui/icons-material";
import { Countdown } from "../../components/common/Countdown";
import FormGroup from "@mui/material/FormGroup";
import dayjs from "dayjs";

const LoginPage = ({ store }) => {
  let navigate = useNavigate();

  const [mobilePhone, setMobilePhone] = useState("");
  const [password, setPassword] = useState("");
  const [smsCode, setSmsCode] = useState("");
  const [errorCount, setErrorCount] = useState(0);
  const [captchaValue, setCaptchaValue] = useState("");
  const [loginStep, setLoginStep] = useState(0);
  const [countInputDate, setCountInputDate] = useState(dayjs());
  const [code, setCode] = useState("");
  const [forgetPwdDialog, setForgetPwdDialog] = useState(false);
  const [parolamiUnuttumDisplay, setParolamiUnuttumDisplay] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [reNewpassword, setReNewpassword] = useState("");
  const [passwordHelperTitle, setPasswordHelperTitle] = useState("");
  const [passwordErrorStatus, setPasswordErrorStatus] = useState(false);
  const [repasswordHelperTitle, setRepasswordHelperTitle] = useState("");
  const [repasswordErrorStatus, setRepasswordErrorStatus] = useState(false);
  const [repasswordShowStatus, setRepasswordShowStatus] = useState(false);
  const [passwordShowStatus, setPasswordShowStatus] = useState(false);
  const [parolamiUnuttumCode, setParolamiUnuttumCode] = useState("");
  const [parolamiUnuttumNewPassword, setParolamiUnuttumNewPassword] =
    useState("");
  const [parolamiUnuttumReNewpassword, setParolamiUnuttumReNewpassword] =
    useState("");
  const [redirect, setRedirect] = useState(false);
  const [showAgreement, setShowAgreement] = useState("");

  useEffect(() => {
    store.setLoadingBarStatus(true);
  }, [store]);

  const textfieldChange = (event) => {
    setMobilePhone(event.target.value);
  };

  const passwordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleForgetPwd = () => {
    setForgetPwdDialog(!forgetPwdDialog);
  };

  const loginRequest = async () => {
    let response = await userLogin(store.baseUrl, mobilePhone, password);
    if (response != null) {
      if (response.status === 200) {
        setCountInputDate(dayjs());
        setLoginStep(1);
        setSmsCode(response.data?.code);
        if (showAgreement === "") {
          setShowAgreement(!response.data?.pastLogin);
        }
      } else {
        store.setToken("");
        setErrorCount((prevState) => prevState + 1);
        store.setMessage(response.data, true, "error");
      }
    } else {
      store.setMessage("Servis altyapısında problem oluştu", true);
    }
  };

  const onClickLoginFirstStep = async () => {
    store.setLoadingBarStatus(false);
    if (mobilePhone.trim() !== "" && password.trim() !== "") {
      let queryable = false;

      if (errorCount > 1) {
        if (captchaValue !== "") {
          queryable = true;
        } else {
          queryable = false;
          store.setMessage(
            "Robot değilim kontrolünü tamamlamalısınız.",
            true,
            "error"
          );
        }
      } else {
        queryable = true;
      }

      if (queryable) {
        await loginRequest();
      }
    } else {
      store.setMessage(
        "Giriş yapmak için kullanıcı bilgilerinizi eksiksiz giriniz.",
        true
      );
    }
    store.setLoadingBarStatus(true);
  };

  const onClickLoginSecondStep = async () => {
    store.setLoadingBarStatus(false);

    if (smsCode !== "") {
      let response = await userLoginSMS(
        store.baseUrl,
        mobilePhone,
        password,
        smsCode
      );

      if (response != null) {
        if (response.status === 200) {
          let user = response.data;
          store.setTrainer(user.data);
          store.setLoadingBarStatus(true);
          navigate("/project");
        } else {
          store.setToken("");
          store.setMessage(response.data, true, "error");
        }
      } else {
        store.setMessage("Servis altyapısında problem oluştu", true, "error");
      }
    } else {
      store.setMessage("SMS kodunu girmeniz gerekmektedir", true, "error");
    }
    store.setLoadingBarStatus(true);
  };

  return (
    <div className="container mps-container bg-image">
      <Grid container style={{ width: "100%" }}>
        <Grid
          item
          xs={3}
          className="height100vh"
          sx={{
            padding: { xs: "25px", sm: "50px" },
            background: "#fff",
            minWidth: { xs: "100%", sm: "500px" },
            paddingRight: { sm: "100px !important" },
          }}
        >
          <img
            src="/assets/images/wholemedics-logo.png"
            alt="wholemedics"
            style={{ width: "250px" }}
          ></img>

          <Box
            component="div"
            sx={{
              paddingLeft: { xs: "unset", sm: "50px" },
              display: loginStep === 0 ? "block" : "none",
            }}
          >
            <Typography
              variant="h4"
              style={{
                textAlign: "left",
                fontWeight: "4bold00",
                marginTop: "75px",
                marginBottom: "30px",
              }}
            >
              Görüşme paneline hoşgeldin!
            </Typography>

            <TextField
              variant="outlined"
              style={{
                width: "100%",
                marginBottom: "10px",
                background: "#ffece2",
                borderRadius: "10px",
              }}
              label="Telefon Numarası"
              onChange={textfieldChange}
              autoComplete="off"
            />
            <TextField
              variant="outlined"
              type="password"
              label="Parola"
              style={{
                width: "100%",
                marginBottom: "20px",
                background: "#ffece2",
                borderRadius: "10px",
                border: "0",
              }}
              onChange={passwordChange}
            />

            {errorCount > 1 ? (
              <ReCAPTCHA
                style={{ marginBottom: "15px" }}
                hl="tr"
                sitekey="6Ld9ghgjAAAAADIr4XcEN-aWyBxlzniwhJbujQWG"
                onChange={(value) => setCaptchaValue(value)}
              />
            ) : null}

            <FormGroup style={{ marginTop: "10px", marginBottom: "10px" }}>
              <Typography
                variant="subtitle2"
                color="default"
                style={{ marginTop: "10px", fontSize: "13px" }}
              >
                Kişisel verilerinizin işlenmesi hakkında detaylı bilgi için
                <a
                  href="https://saglikcim.net/kisisel-verilerin-korunmasi"
                  style={{
                    color: "inherit",
                    textDecoration: "underline",
                    fontWeight: "bold",
                    marginLeft: "5px",
                  }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Kişisel Verilerin İşlenmesi Hakkındaki Aydınlatma Metnini
                </a>
                'ni okuyabilirsiniz
              </Typography>
            </FormGroup>

            <Button
              variant="contained"
              color="primary"
              onClick={onClickLoginFirstStep}
              style={{ width: "100%", height: "50px", fontWeight: "bold" }}
            >
              GİRİŞ YAP
            </Button>
            <LinearProgress
              style={{
                display: store.loadingBarStatus ? "none" : "block",
                width: "calc(100% - 18px)",
                marginLeft: "9px",
              }}
            />
          </Box>
          <Box
            component="div"
            sx={{
              paddingLeft: { xs: "unset", sm: "50px" },
              display: loginStep === 1 ? "block" : "none",
            }}
          >
            <Typography style={{ marginTop: "50px", fontWeight: "bold" }}>
              SMS Kodu Doğrulama
            </Typography>
            <Typography variant="body1">
              Cep telefonu numaranıza gönderilen sms kodunu giriniz.
            </Typography>
            <TextField
              id="outlined-basic2"
              variant="outlined"
              name="tckno"
              style={{
                width: "100%",
                marginBottom: "10px",
                borderRadius: "10px",
                marginTop: "10px",
              }}
              value={smsCode}
              label="SMS Kodu*"
              onChange={(event) => setSmsCode(event.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={onClickLoginFirstStep}
                    >
                      Tekrar Gönder
                    </Button>
                  </InputAdornment>
                ),
              }}
              autoComplete="one-time-code"
            />
            <Countdown date={countInputDate} time={180000} />

            <Button
              variant="contained"
              color="primary"
              onClick={onClickLoginSecondStep}
              style={{
                width: "100%",
                height: "50px",
                fontWeight: "bold",
                marginTop: "10px",
              }}
            >
              GİRİŞ YAP
            </Button>
            <LinearProgress
              style={{
                display: store.loadingBarStatus ? "none" : "block",
                width: "calc(100% - 18px)",
                marginLeft: "9px",
              }}
            />
          </Box>
          {/* <Button
            style={{
              fontSize: "14px",
              textDecoration: "none",
              fontWeight: "bold",
              float: "right",
              marginTop: "10px",
            }}
            onClick={handleForgetPwd}
            color="primary"
          >
            Parolamı unuttum
          </Button> */}
        </Grid>
      </Grid>
      <Dialog open={forgetPwdDialog} maxWidth={"sm"} fullWidth>
        <AppBar
          sx={{ position: "relative", background: "#ff5969" }}
          color="primary"
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleForgetPwd}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Parolamı Unuttum
            </Typography>
          </Toolbar>
        </AppBar>
        <div
          style={{
            position: "absolute",
            height: "5px",
            width: "100%",
            zIndex: "5000",
          }}
        >
          <LinearProgress
            style={{
              display: store.loadingBarStatus ? "none" : "block",
            }}
            color="primary"
          />
        </div>
        <DialogContent style={{ padding: "30px" }}>
          <Paper
            elevation={0}
            style={{
              width: "100%",
              minHeight: "100px",
              display: parolamiUnuttumDisplay ? "block" : "none",
            }}
          >
            <Grid container spacing={3} style={{ width: "100%" }}>
              <Grid item xs={12}>
                <TextField
                  value={mobilePhone}
                  onChange={(event) =>
                    setMobilePhone(event.target.value)
                  }
                  label="Telefon Numarası"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </Paper>

          <Paper
            elevation={0}
            style={{
              width: "100%",
              minHeight: "100px",
              display: !parolamiUnuttumDisplay ? "block" : "none",
            }}
          >
            <Grid item xs={12}>
              <Countdown date={countInputDate} time={180000} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic3"
                variant="outlined"
                name="password"
                type="text"
                value={parolamiUnuttumCode}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  borderRadius: "10px",
                  marginTop: "10px",
                }}
                label="SMS Kodu"
                onChange={(event) => setParolamiUnuttumCode(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic4"
                variant="outlined"
                name="password"
                type={passwordShowStatus ? "text" : "password"}
                value={newPassword}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  borderRadius: "10px",
                  marginTop: "10px",
                }}
                label="Şifreniz*"
                onChange={(event) => setNewPassword(event.target.value)}
                helperText={passwordHelperTitle}
                error={passwordErrorStatus}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          setPasswordShowStatus(!passwordShowStatus)
                        }
                        onMouseDown={(event) => event.preventDefault()}
                        edge="end"
                      >
                        {passwordShowStatus ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic5"
                variant="outlined"
                name="repassword"
                type={repasswordShowStatus ? "text" : "password"}
                value={reNewpassword}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  borderRadius: "10px",
                  marginTop: "10px",
                }}
                label="Şifreniz (tekrar)*"
                onChange={(event) => setReNewpassword(event.target.value)}
                helperText={repasswordHelperTitle}
                error={repasswordErrorStatus}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          setRepasswordShowStatus(!repasswordShowStatus)
                        }
                        onMouseDown={(event) => event.preventDefault()}
                        edge="end"
                      >
                        {repasswordShowStatus ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Paper>
        </DialogContent>
        {/* <DialogActions>
          {parolamiUnuttumDisplay ? (
            <Button
              variant="contained"
              color="primary"
              onClick={onClickForgotPassword}
              style={{ height: "55px", float: "right" }}
            >
              Parolamı Sıfırla
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={onClickPasswordUpdate}
            >
              Parolamı Değiştir
            </Button>
          )}
        </DialogActions> */}
      </Dialog>
      <AlertComponent />
    </div>
  );
};

export default inject("store")(observer(LoginPage));
